/**
 * RSA Overseas monogram — HD raster mark on true transparency.
 * Source: /rsa-logo.png (1024x1024, background AI-cleaned to alpha=0).
 * We render it via <img> so it inherits our layout sizing and stays crisp
 * across all breakpoints.
 */
export default function Logo({ className = "h-11 w-11", title = "RSA Overseas monogram" }) {
  return (
    <img
      src="/rsa-symbol.png"
      alt={title}
      className={`${className} object-contain select-none`}
      draggable={false}
      loading="eager"
      decoding="async"
    />
  );
}
